import { createNav, bindNav } from "./components/Nav.js";
import { createFooter } from "./sections/Footer.js";
import {
  createProductDetailHero,
  createProductDetailBody,
} from "./sections/product/ProductDetail.js";
import {
  getProductDetail,
  productDetailHomeHref,
  productDetailRoute,
} from "../config/productDetails.js";

export function mountProductDetailPage(root, slug) {
  const detail = getProductDetail(slug);

  if (!detail) {
    window.location.replace(productDetailHomeHref());
    return {
      canvas: null,
      updateNavActive: () => {},
      documentTitle: "Taldel — Product not found",
      sections: {},
    };
  }

  if (detail.slug && slug && detail.slug !== String(slug).toLowerCase()) {
    window.location.replace(productDetailRoute(detail.slug));
    return {
      canvas: null,
      updateNavActive: () => {},
      documentTitle: `Taldel — ${detail.title}`,
      sections: {},
    };
  }

  const canvasLayer = document.createElement("div");
  canvasLayer.className = "canvas-layer";
  canvasLayer.innerHTML = `<canvas id="canvas" aria-hidden="true"></canvas>`;

  const contentLayer = document.createElement("div");
  contentLayer.className = "content-layer content-layer--product-detail";

  const nav = createNav();

  contentLayer.append(
    nav,
    createProductDetailHero(detail),
    createProductDetailBody(detail),
    createFooter()
  );

  root.append(canvasLayer, contentLayer);

  const updateNavActive = bindNav(nav, {
    page: "product-detail",
    sectionMap: {
      overview: productDetailRoute(detail.slug, "overview"),
      details: productDetailRoute(detail.slug, "details"),
      next: productDetailRoute(detail.slug, "next"),
    },
  });

  return {
    canvas: canvasLayer.querySelector("#canvas"),
    updateNavActive,
    documentTitle: `Taldel — ${detail.title}`,
    sections: {
      overview: contentLayer.querySelector("#overview"),
      details: contentLayer.querySelector("#details"),
      next: contentLayer.querySelector("#next"),
    },
    detail,
  };
}
